import type { ITrack } from '@similarweb/sw-track';
import { AggregatedTracker, ConsoleTracker } from '@similarweb/sw-track';

import { initMatomoTracker, matomoTracker } from './matomoTracker';
import { mixpanelTracker, initMixpanelTracker } from './mixpanelTracker';

export const allTrackers = new AggregatedTracker([
  mixpanelTracker as ITrack,
  matomoTracker as ITrack,
  new ConsoleTracker('allTrackers') as unknown as ITrack,
]);

export const initTracking = () => {
  initMixpanelTracker();
  initMatomoTracker();
};
